import { stateMerge } from "vue-object-merge";
import * as mutation from "./mutation-types";
import { getBlankRecord, getBlankCriteria } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    state.listing.criteria = getBlankCriteria();
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, logs) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = logs;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.VIEW_STARTED](state, userId) {
    state.view.loading = true;
    state.view.userId = userId;
  },
  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.loaded = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
    state.view.loaded = false;
  },
  [mutation.VIEW_SUCCEEDED](state, user) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, user);
    state.view.breadcrumbs = [];
    state.view.breadcrumbs.push({
      text: "Users",
      path: "/users"
    });
    state.view.breadcrumbs.push({
      text: user.familyName ? `${user.firstName} ${user.familyName}` : user.emailAddress
    });
  },
  [mutation.VIEW_MFA_PROFILE_STARTED](state) {
    state.viewMfaProfile.loading = true;
  },
  [mutation.VIEW_MFA_PROFILE_SUCCEEDED](state, userMfaProfile) {
    state.viewMfaProfile.loading = false;
    state.viewMfaProfile.loaded = true;
    stateMerge(state.viewMfaProfile.data, userMfaProfile);
  },
  [mutation.VIEW_MFA_PROFILE_FAILED](state) {
    state.viewMfaProfile.loading = false;
    state.viewMfaProfile.loaded = false;
  },
  [mutation.EDIT_SET_DATA](state, details) {
    stateMerge(state.edit.data, details);
  },
  [mutation.EDIT_GET_STARTED](state) {
    state.edit.loading = true;
    state.edit.error.show = false;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },
  [mutation.EDIT_GET_SUCCEEDED](state, user) {
    state.edit.loading = false;
    stateMerge(state.edit.data, user);
  },

  [mutation.EDIT_SAVE_STARTED](state) {
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state, user) {
    state.edit.saving = false;
    stateMerge(state.edit.data, user);
  },
  [mutation.DISABLE_MFA_STARTED](state) {
    state.updateUserMfa.saving = true;
    state.updateUserMfa.error.show = false;
  },
  [mutation.DISABLE_MFA_SUCCEEDED](state) {
    state.updateUserMfa.saving = false;
  },
  [mutation.DISABLE_MFA_FAILED](state, error) {
    state.updateUserMfa.saving = false;
    state.updateUserMfa.error.show = true;
    state.updateUserMfa.error.details = error;
  },
  [mutation.ENABLE_MFA_STARTED](state) {
    state.updateUserMfa.saving = true;
    state.updateUserMfa.error.show = false;
  },
  [mutation.ENABLE_MFA_SUCCEEDED](state) {
    state.updateUserMfa.saving = false;
  },
  [mutation.ENABLE_MFA_FAILED](state, error) {
    state.updateUserMfa.saving = false;
    state.updateUserMfa.error.show = true;
    state.updateUserMfa.error.details = error;
  },
  [mutation.SWITCH_TO_EMAIL_MFA_STARTED](state) {
    state.updateUserMfa.saving = true;
    state.updateUserMfa.error.show = false;
  },
  [mutation.SWITCH_TO_EMAIL_MFA_SUCCEEDED](state) {
    state.updateUserMfa.saving = false;
  },
  [mutation.SWITCH_TO_EMAIL_MFA_FAILED](state, error) {
    state.updateUserMfa.saving = false;
    state.updateUserMfa.error.show = true;
    state.updateUserMfa.error.details = error;
  },
 
  /* Setup MFA */
  [mutation.SETUP_AUTHENTICATOR_APP_MFA_STARTED](state) {
    state.setupAuthenticatorMfa.setup.saving = true;
    state.setupAuthenticatorMfa.setup.error.show = false;
  },
  [mutation.SETUP_AUTHENTICATOR_APP_MFA_SUCCEEDED](state){
    state.setupAuthenticatorMfa.setup.saving = false;
  },
  [mutation.SETUP_AUTHENTICATOR_APP_MFA_FAILED](state, error) {
    state.setupAuthenticatorMfa.setup.saving = false;
    state.setupAuthenticatorMfa.setup.error.show = true;
    state.setupAuthenticatorMfa.setup.error.details = error;
  },

  [mutation.SETUP_AUTHENTICATOR_APP_MFA_GET_STARTED](state) {
    state.setupAuthenticatorMfa.get.data = {};
    state.setupAuthenticatorMfa.get.loading = true;
  },

  [mutation.SETUP_AUTHENTICATOR_APP_MFA_GET_SUCCEEDED](state, details) {
    state.setupAuthenticatorMfa.get.loading = false;
    state.setupAuthenticatorMfa.setup.data.secretInBase32 = details.secretInBase32;
    stateMerge(state.setupAuthenticatorMfa.get.data, details);
  },

  [mutation.SETUP_AUTHENTICATOR_APP_MFA_GET_FAILED](state, error) {
    state.setupAuthenticatorMfa.get.loading = false;
  },
};
